export default "__VITE_ASSET__2b31b286__"